<template>
  <div class="boty">
<!-- <Card /> -->
    <fieldset class="frame">
      <legend style="padding:20px;text-align:center">Interessantes und Aktuelles</legend>
      
      <div class="posts-page">
        <div class="post-list">
          <PostPreview v-for="post in featuredPosts" :key="post.id" :post="post" />
        </div>
      </div>
    </fieldset>

    <fieldset class="frame">
      <legend style="padding:20px;text-align:center">Zur interaktiven Karte</legend>
      <div class="card-map">
        <figure class="image">
          <router-link to="/angebote">
            <img src="@/assets/images/map.png">
            <figcaption class="figure-caption" style="text-align: center; margin-top: 5px"><button class="button">Zur Karte</button></figcaption>
          </router-link>
        </figure>
      </div>
    </fieldset>
  </div>
</template>

<script>
import db from "../db"
import PostPreview from '@/components/PostPreview'

export default {
  data() {
    return {
      featuredPosts: [],
    }
  },
  components: {
    PostPreview
  },
  firestore: {
    featuredPosts: db.collection('posts').where('featured', '==', true).limit(3)
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/main.scss';

.frame {
  margin: 25px 15px 15px 15px;
  border: 1.5px;
  border-style: solid;
  border-color: $primaryBorder;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  color: $primaryBorder;
}

.boty {
  min-height: 60vw;
}

.card-map {
  display: flex;
  justify-content: center;
  padding: 15px;
// background-color: cornsilk;
  height: 250px;
  min-width: 80%;
  font-family: Arial, Helvetica, sans-serif;
}

.button {
  background-color: $primaryDark;
  color: $white;
}

</style>^
